// DEA — traido de dan_branch el 2026-09-08.
(() => {
  if (window.NewEraWishlistGalleryPlacement) return;

  let isScheduled = false;

  const placeWishlistButton = (productForm) => {
    const mediaGallery = productForm.querySelector('media-gallery');
    const wishlistButton = productForm.querySelector('wishlist-button-block');

    if (!mediaGallery || !wishlistButton) return;

    const wishlistBlock = wishlistButton.closest('.wishlist-gallery-button')
      || wishlistButton.closest('.product-form > div');

    if (!wishlistBlock || wishlistBlock.parentElement === mediaGallery) return;

    wishlistBlock.classList.add('wishlist-gallery-button');
    mediaGallery.insertAdjacentElement('afterbegin', wishlistBlock);
  };

  const initialize = (scope = document) => {
    const productForms = [];

    if (scope instanceof Element && scope.matches('product-form')) {
      productForms.push(scope);
    }

    if (scope.querySelectorAll) {
      productForms.push(...scope.querySelectorAll('product-form'));
    }

    productForms.forEach(placeWishlistButton);
  };

  const scheduleInitialization = () => {
    if (isScheduled) return;

    isScheduled = true;
    window.requestAnimationFrame(() => {
      isScheduled = false;
      initialize();
    });
  };

  const onReady = () => {
    initialize();

    const observer = new MutationObserver(scheduleInitialization);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  window.NewEraWishlistGalleryPlacement = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
